export default __webpack_public_path__ + "locales/hy-AM/ChangeUserTypeDialog.json?hash=221e8972b0b618a72121c8055be53dcf";